(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .factory('LabNotificationSearch', LabNotificationSearch);

    LabNotificationSearch.$inject = ['$resource'];

    function LabNotificationSearch($resource) {
        var resourceUrl =  'api/_search/lab-notifications/:id';

        return $resource(resourceUrl, {}, {
            'query': { method: 'GET', isArray: true}
        });
    }
})();
